/**
 * Zellformatierung der Frametabelle — Gegenstücke zu FormatCanIdDisplay()
 * und den snprintf-Aufrufen in AppendFrameTrace()/AppendFrameStatic().
 *
 * Bewusst allokationsarm: bei 5.000 Frames/s darf hier nichts pro Frame
 * anfallen. Formatiert wird deshalb erst beim Zeichnen, für die ~50
 * sichtbaren Zeilen (siehe FrameTable-Kopfkommentar).
 */

/** "00".."FF" — schneller als toString(16).padStart() im Zeichenpfad. */
const HEX_BYTE: readonly string[] = Array.from({ length: 256 }, (_, i) =>
  i.toString(16).toUpperCase().padStart(2, '0'),
);

export function hexByte(value: number): string {
  return HEX_BYTE[value & 0xff] as string;
}

/**
 * Spalte "ID Hex". 29-Bit-IDs werden als "<Prio+DP> <PGN> <SA>" gruppiert
 * (z. B. "1C FEFF 80"), damit die J1939-Struktur auf einen Blick lesbar ist;
 * 11-Bit-IDs bleiben dreistellig ohne "0x" (die Spaltenüberschrift sagt Hex).
 * Kriterium ist wie im Original der Zahlenwert, nicht das extended-Flag.
 */
export function formatCanIdDisplay(id: number): string {
  if (id > 0x7ff) {
    const prio = hexByte((id >>> 24) & 0xff);
    const pgn = ((id >>> 8) & 0xffff).toString(16).toUpperCase().padStart(4, '0');
    return `${prio} ${pgn} ${hexByte(id & 0xff)}`;
  }
  return id.toString(16).toUpperCase().padStart(3, '0');
}

/** Umkehrung von formatCanIdDisplay() — Gegenstück zu ParseCanIdDisplay(). */
export function parseCanIdDisplay(text: string): number {
  const cleaned = text.replace(/\s+/g, '').replace(/^0[xX]/, '');
  const value = Number.parseInt(cleaned, 16);
  return Number.isFinite(value) ? value >>> 0 : 0;
}

/** Spalte "dt(ms)" — "%.2f" wie im Original. */
export function formatMillis(value: number): string {
  return value.toFixed(2);
}
